__turbopack_context__.v({
  "container": "PostItem-module__3djgkq__container",
  "fadeInItems": "PostItem-module__3djgkq__fadeInItems",
  "img": "PostItem-module__3djgkq__img",
  "imgWrap": "PostItem-module__3djgkq__imgWrap",
  "light": "PostItem-module__3djgkq__light",
  "spacing--lg": "PostItem-module__3djgkq__spacing--lg",
  "spacing--md": "PostItem-module__3djgkq__spacing--md",
  "spacing--sm": "PostItem-module__3djgkq__spacing--sm",
  "spacing--xl": "PostItem-module__3djgkq__spacing--xl",
  "spacing--xs": "PostItem-module__3djgkq__spacing--xs",
  "spacing--xxl": "PostItem-module__3djgkq__spacing--xxl",
  "spacing--xxs": "PostItem-module__3djgkq__spacing--xxs",
  "spacing--xxxl": "PostItem-module__3djgkq__spacing--xxxl",
  "spacing--xxxs": "PostItem-module__3djgkq__spacing--xxxs",
  "tag": "PostItem-module__3djgkq__tag",
  "title": "PostItem-module__3djgkq__title",
});
